function getValidURL(url: string): string {
  const isPortIncluded = url.includes('http') || url.includes('https');
  if (isPortIncluded) {
    return url;
  }
  return `http://${url}`;
}

export { getValidURL };
